import styled from 'styled-components';
import defaultIcon from 'assets/default-project-icon.svg';

const DEFAULT_ICON_SIZE = 12;

const Image = styled.img.attrs(({ $size }) => ({
  width: $size,
  height: $size,
}))`
  min-width: ${({ $size }) => $size}px;
`;

/**
 * @param {object} props -
 * @param {string} props.label - the label for the icon
 * @param {string} props.src - the source of the icon
 * @param {number} props.size - the size of the icon
 */
export default function ProjectTypeIcon({ label, src, size }) {
  return (
    <Image
      src={src || defaultIcon}
      alt={`${label}-icon`}
      $size={size || DEFAULT_ICON_SIZE}
    />
  );
}
